import YoungPersonProfileView from './YoungPersonProfileViewContainer';
export default YoungPersonProfileView;
